import React from 'react';

function AccordionSection({ title, isOpen, isCompleted, canOpen, children, InfoChildren,onBack, showBackButton }) {
  return (
    <div className={`border dark:border-gray-700 rounded-lg mb-4
                          // ${isOpen ? 'ring-2 ring-blue-500 dark:border-sky-200/50 shadow-lg shadow-blue-500/50 dark:shadow-blue-700/50 ' : ''}

                    ${isOpen ? 'ring-2 ring-blue-500 shadow-lg shadow-blue-500/50 dark:shadow-blue-700/50 ' : ''}
                    ${!canOpen ? 'opacity-50' : ''}`}>
      <div className={`p-4 flex items-center justify-between
                      ${isCompleted ? 'bg-green-50 dark:bg-green-900/30 text-green-900 dark:text-green-100' :
                        isOpen ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-900 dark:text-blue-100' :
                        'bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100'}`}>
        <div className="flex items-center space-x-4">
          {showBackButton && isOpen && (
            <button
              onClick={onBack}
              className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 flex items-center transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
              Retour
            </button>
          )}
          <div className="flex items-center">
            {isCompleted && (
              <svg className="w-6 h-6 text-green-500 dark:text-green-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            )}
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">{title}</h3>
            {isCompleted && !isOpen && (
              InfoChildren
            )}
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="p-4 border-t dark:border-gray-700 bg-white dark:bg-blue-900/10 rounded-b-lg">
          {children}
        </div>
      )}
    </div>
  );
}

export default AccordionSection;